import type { NetGame } from '@orb/net';

/** The tab's seat: the server's session token, valid only for the room it was taken in. */
export const seat = {
  load(room: string): string | null {
    try { const v = JSON.parse(sessionStorage.getItem('orb.session') ?? 'null'); return v && v.code === room && typeof v.token === 'string' ? v.token : null; } catch { return null; }
  },
  keep(code: string, token: string) { try { sessionStorage.setItem('orb.session', JSON.stringify({ code, token })); } catch { /* private mode */ } },
  forget() { try { sessionStorage.removeItem('orb.session'); } catch { /* private mode */ } },
};

/**
 * Leaving a match on purpose: the server frees the seat (the ally hears «left», not «lost connection»)
 * and the tab forgets it, so the next room, code or invite isn't swallowed by a resume.
 */
export function leaveMatch(net: NetGame) { net.leave(); seat.forget(); }
